module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargador-dbb2d71d.png";